import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * 网络话筒列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	micPhoneList( params={} ) {
		return request({
	    url: baseUrl + '/device/breakers/micList',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 网络话筒 打开
	 * @param {device_id} 设备mic_id
	 * @return {terminal_number}  设备ID
	**/
	micPhoneOpen(data){
		return request({
			url: baseUrl + '/device/breakers/micOpen',
			method:'POST',
			data
		})
	},

	/**
	 * 网络话筒 关闭
	 * @param {device_id} 设备mic_id
	**/
	micPhoneClose(data){
		return request({
			url: baseUrl + '/device/breakers/micClose',
			method:'POST',
			data
		})
	},
}